// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file gd.proto (package gd.v1, syntax proto3)
/* eslint-disable */

// Grovedock wire protocol. Every object request names an immutable, content-addressed
// object, so any tier (server, regional cache, node daemon) can answer it.

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gd.proto.
 */
export const file_gd: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message gd.v1.Empty
 */
export type Empty = Message<"gd.v1.Empty"> & {
};

/**
 * Describes the message gd.v1.Empty.
 * Use `create(EmptySchema)` to create a new message.
 */
export const EmptySchema: GenMessage<Empty> = /*@__PURE__*/
  messageDesc(file_gd, 0);

/**
 * @generated from message gd.v1.IdMsg
 */
export type IdMsg = Message<"gd.v1.IdMsg"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;
};

/**
 * Describes the message gd.v1.IdMsg.
 * Use `create(IdMsgSchema)` to create a new message.
 */
export const IdMsgSchema: GenMessage<IdMsg> = /*@__PURE__*/
  messageDesc(file_gd, 1);

/**
 * @generated from message gd.v1.IdList
 */
export type IdList = Message<"gd.v1.IdList"> & {
  /**
   * @generated from field: repeated bytes ids = 1;
   */
  ids: Uint8Array[];
};

/**
 * Describes the message gd.v1.IdList.
 * Use `create(IdListSchema)` to create a new message.
 */
export const IdListSchema: GenMessage<IdList> = /*@__PURE__*/
  messageDesc(file_gd, 2);

/**
 * Object payload exactly as stored: 1 kind byte followed by zstd-compressed content.
 * Receivers verify id == blake3(kind || content) before trusting it.
 *
 * @generated from message gd.v1.ObjectPayload
 */
export type ObjectPayload = Message<"gd.v1.ObjectPayload"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;
};

/**
 * Describes the message gd.v1.ObjectPayload.
 * Use `create(ObjectPayloadSchema)` to create a new message.
 */
export const ObjectPayloadSchema: GenMessage<ObjectPayload> = /*@__PURE__*/
  messageDesc(file_gd, 3);

/**
 * @generated from message gd.v1.PutObjectsResponse
 */
export type PutObjectsResponse = Message<"gd.v1.PutObjectsResponse"> & {
  /**
   * @generated from field: uint32 stored = 1;
   */
  stored: number;
};

/**
 * Describes the message gd.v1.PutObjectsResponse.
 * Use `create(PutObjectsResponseSchema)` to create a new message.
 */
export const PutObjectsResponseSchema: GenMessage<PutObjectsResponse> = /*@__PURE__*/
  messageDesc(file_gd, 4);

/**
 * @generated from message gd.v1.FileChange
 */
export type FileChange = Message<"gd.v1.FileChange"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * empty => delete
   *
   * @generated from field: bytes blob = 2;
   */
  blob: Uint8Array;

  /**
   * @generated from field: int32 mode = 3;
   */
  mode: number;
};

/**
 * Describes the message gd.v1.FileChange.
 * Use `create(FileChangeSchema)` to create a new message.
 */
export const FileChangeSchema: GenMessage<FileChange> = /*@__PURE__*/
  messageDesc(file_gd, 5);

/**
 * @generated from message gd.v1.ChangesetInfo
 */
export type ChangesetInfo = Message<"gd.v1.ChangesetInfo"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: bytes root_tree = 2;
   */
  rootTree: Uint8Array;

  /**
   * @generated from field: uint64 generation = 3;
   */
  generation: bigint;

  /**
   * Canonical changeset encoding; clients may re-hash it to verify `id`.
   *
   * @generated from field: bytes encoded = 4;
   */
  encoded: Uint8Array;

  /**
   * Changes outside the caller's read scope were removed, so `encoded` no longer hashes
   * to `id` and cannot be verified by the client.
   *
   * @generated from field: bool redacted = 5;
   */
  redacted: boolean;

  /**
   * Who uploaded it, as this server recorded it; absent for changes from before this was kept.
   *
   * @generated from field: gd.v1.Provenance provenance = 6;
   */
  provenance?: Provenance | undefined;
};

/**
 * Describes the message gd.v1.ChangesetInfo.
 * Use `create(ChangesetInfoSchema)` to create a new message.
 */
export const ChangesetInfoSchema: GenMessage<ChangesetInfo> = /*@__PURE__*/
  messageDesc(file_gd, 6);

/**
 * Who made a change: the signed-in account that uploaded it (not what the change says about
 * itself), and what an agent declared when it did. Kept beside the change, not in its message.
 *
 * @generated from message gd.v1.Provenance
 */
export type Provenance = Message<"gd.v1.Provenance"> & {
  /**
   * @generated from field: string by = 1;
   */
  by: string;

  /**
   * @generated from field: bool agent = 2;
   */
  agent: boolean;

  /**
   * @generated from field: string model = 3;
   */
  model: string;

  /**
   * @generated from field: string session = 4;
   */
  session: string;

  /**
   * The issue it's for, 0 if none.
   *
   * @generated from field: uint64 task = 5;
   */
  task: bigint;

  /**
   * @generated from field: int64 at_ms = 6;
   */
  atMs: bigint;
};

/**
 * Describes the message gd.v1.Provenance.
 * Use `create(ProvenanceSchema)` to create a new message.
 */
export const ProvenanceSchema: GenMessage<Provenance> = /*@__PURE__*/
  messageDesc(file_gd, 7);

/**
 * @generated from message gd.v1.CreateChangesetRequest
 */
export type CreateChangesetRequest = Message<"gd.v1.CreateChangesetRequest"> & {
  /**
   * @generated from field: repeated bytes parents = 1;
   */
  parents: Uint8Array[];

  /**
   * @generated from field: repeated gd.v1.FileChange changes = 2;
   */
  changes: FileChange[];

  /**
   * @generated from field: string author = 3;
   */
  author: string;

  /**
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * @generated from field: int64 timestamp_ms = 5;
   */
  timestampMs: bigint;

  /**
   * An encoded gd.objects.v1.GitOrigin, for a change that came from git (imports, git pushes).
   *
   * @generated from field: bytes git = 6;
   */
  git: Uint8Array;

  /**
   * An agent's own account of itself, recorded in the change's provenance: the model, its
   * session (conversation) id, and the issue it's working on.
   *
   * @generated from field: string model = 7;
   */
  model: string;

  /**
   * @generated from field: string session = 8;
   */
  session: string;

  /**
   * @generated from field: uint64 task = 9;
   */
  task: bigint;

  /**
   * CreateMany only: the parents, in order, each an existing change or one made earlier on the
   * same stream. When set, `parents` must be empty.
   *
   * @generated from field: repeated gd.v1.ParentRef parent_refs = 10;
   */
  parentRefs: ParentRef[];
};

/**
 * Describes the message gd.v1.CreateChangesetRequest.
 * Use `create(CreateChangesetRequestSchema)` to create a new message.
 */
export const CreateChangesetRequestSchema: GenMessage<CreateChangesetRequest> = /*@__PURE__*/
  messageDesc(file_gd, 8);

/**
 * A parent of a change sent to CreateMany.
 *
 * @generated from message gd.v1.ParentRef
 */
export type ParentRef = Message<"gd.v1.ParentRef"> & {
  /**
   * @generated from oneof gd.v1.ParentRef.parent
   */
  parent: {
    /**
     * @generated from field: bytes id = 1;
     */
    value: Uint8Array;
    case: "id";
  } | {
    /**
     * The change created at this position (from 0) earlier on the same stream.
     *
     * @generated from field: uint32 earlier = 2;
     */
    value: number;
    case: "earlier";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gd.v1.ParentRef.
 * Use `create(ParentRefSchema)` to create a new message.
 */
export const ParentRefSchema: GenMessage<ParentRef> = /*@__PURE__*/
  messageDesc(file_gd, 9);

/**
 * @generated from message gd.v1.CreatedChangeset
 */
export type CreatedChangeset = Message<"gd.v1.CreatedChangeset"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;
};

/**
 * Describes the message gd.v1.CreatedChangeset.
 * Use `create(CreatedChangesetSchema)` to create a new message.
 */
export const CreatedChangesetSchema: GenMessage<CreatedChangeset> = /*@__PURE__*/
  messageDesc(file_gd, 10);

/**
 * @generated from message gd.v1.ResolveRequest
 */
export type ResolveRequest = Message<"gd.v1.ResolveRequest"> & {
  /**
   * @generated from field: string rev = 1;
   */
  rev: string;
};

/**
 * Describes the message gd.v1.ResolveRequest.
 * Use `create(ResolveRequestSchema)` to create a new message.
 */
export const ResolveRequestSchema: GenMessage<ResolveRequest> = /*@__PURE__*/
  messageDesc(file_gd, 11);

/**
 * @generated from message gd.v1.RefName
 */
export type RefName = Message<"gd.v1.RefName"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message gd.v1.RefName.
 * Use `create(RefNameSchema)` to create a new message.
 */
export const RefNameSchema: GenMessage<RefName> = /*@__PURE__*/
  messageDesc(file_gd, 12);

/**
 * @generated from message gd.v1.RefValue
 */
export type RefValue = Message<"gd.v1.RefValue"> & {
  /**
   * @generated from field: bool exists = 1;
   */
  exists: boolean;

  /**
   * @generated from field: bytes id = 2;
   */
  id: Uint8Array;
};

/**
 * Describes the message gd.v1.RefValue.
 * Use `create(RefValueSchema)` to create a new message.
 */
export const RefValueSchema: GenMessage<RefValue> = /*@__PURE__*/
  messageDesc(file_gd, 13);

/**
 * @generated from message gd.v1.CasRequest
 */
export type CasRequest = Message<"gd.v1.CasRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bool expect_exists = 2;
   */
  expectExists: boolean;

  /**
   * @generated from field: bytes expected = 3;
   */
  expected: Uint8Array;

  /**
   * @generated from field: bytes new = 4;
   */
  new: Uint8Array;
};

/**
 * Describes the message gd.v1.CasRequest.
 * Use `create(CasRequestSchema)` to create a new message.
 */
export const CasRequestSchema: GenMessage<CasRequest> = /*@__PURE__*/
  messageDesc(file_gd, 14);

/**
 * @generated from message gd.v1.CasResponse
 */
export type CasResponse = Message<"gd.v1.CasResponse"> & {
  /**
   * @generated from field: bool swapped = 1;
   */
  swapped: boolean;
};

/**
 * Describes the message gd.v1.CasResponse.
 * Use `create(CasResponseSchema)` to create a new message.
 */
export const CasResponseSchema: GenMessage<CasResponse> = /*@__PURE__*/
  messageDesc(file_gd, 15);

/**
 * @generated from message gd.v1.RefEntry
 */
export type RefEntry = Message<"gd.v1.RefEntry"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bytes id = 2;
   */
  id: Uint8Array;
};

/**
 * Describes the message gd.v1.RefEntry.
 * Use `create(RefEntrySchema)` to create a new message.
 */
export const RefEntrySchema: GenMessage<RefEntry> = /*@__PURE__*/
  messageDesc(file_gd, 16);

/**
 * @generated from message gd.v1.RefList
 */
export type RefList = Message<"gd.v1.RefList"> & {
  /**
   * @generated from field: repeated gd.v1.RefEntry refs = 1;
   */
  refs: RefEntry[];
};

/**
 * Describes the message gd.v1.RefList.
 * Use `create(RefListSchema)` to create a new message.
 */
export const RefListSchema: GenMessage<RefList> = /*@__PURE__*/
  messageDesc(file_gd, 17);

/**
 * @generated from message gd.v1.LandRequest
 */
export type LandRequest = Message<"gd.v1.LandRequest"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;

  /**
   * @generated from field: bytes changeset = 2;
   */
  changeset: Uint8Array;

  /**
   * As git pushes: the ref moves to the changeset as it is, only if the ref's head is one of
   * its ancestors (or the ref doesn't exist); every changeset it brings is checked as a land
   * would be. Nothing is rebased; otherwise refused ("fetch first").
   *
   * @generated from field: bool fast_forward = 3;
   */
  fastForward: boolean;

  /**
   * Protocol 1.2: a small change in the same call, instead of Objects/Put, Changesets/Create
   * and Land one after another (an agent's usual edit, three round trips to one). The objects
   * are stored and `create` made exactly as those calls would, with the same checks, then
   * landed; `changeset` is left empty. At most 1,024 objects and 4 MiB. A server before 1.2
   * ignores these fields and refuses the empty `changeset` before doing anything, so a client
   * can then make the three calls instead.
   *
   * @generated from field: repeated gd.v1.ObjectPayload objects = 4;
   */
  objects: ObjectPayload[];

  /**
   * @generated from field: gd.v1.CreateChangesetRequest create = 5;
   */
  create?: CreateChangesetRequest | undefined;
};

/**
 * Describes the message gd.v1.LandRequest.
 * Use `create(LandRequestSchema)` to create a new message.
 */
export const LandRequestSchema: GenMessage<LandRequest> = /*@__PURE__*/
  messageDesc(file_gd, 18);

/**
 * @generated from message gd.v1.LandResponse
 */
export type LandResponse = Message<"gd.v1.LandResponse"> & {
  /**
   * @generated from field: bytes landed = 1;
   */
  landed: Uint8Array;

  /**
   * @generated from field: bool rebased = 2;
   */
  rebased: boolean;

  /**
   * @generated from field: uint32 attempts = 3;
   */
  attempts: number;

  /**
   * The change `create` made (protocol 1.2), before any rebase onto the ref.
   *
   * @generated from field: bytes created = 4;
   */
  created: Uint8Array;
};

/**
 * Describes the message gd.v1.LandResponse.
 * Use `create(LandResponseSchema)` to create a new message.
 */
export const LandResponseSchema: GenMessage<LandResponse> = /*@__PURE__*/
  messageDesc(file_gd, 19);

/**
 * @generated from message gd.v1.LogRequest
 */
export type LogRequest = Message<"gd.v1.LogRequest"> & {
  /**
   * @generated from field: string rev = 1;
   */
  rev: string;

  /**
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message gd.v1.LogRequest.
 * Use `create(LogRequestSchema)` to create a new message.
 */
export const LogRequestSchema: GenMessage<LogRequest> = /*@__PURE__*/
  messageDesc(file_gd, 20);

/**
 * @generated from message gd.v1.BlameRequest
 */
export type BlameRequest = Message<"gd.v1.BlameRequest"> & {
  /**
   * @generated from field: string rev = 1;
   */
  rev: string;

  /**
   * @generated from field: string path = 2;
   */
  path: string;
};

/**
 * Describes the message gd.v1.BlameRequest.
 * Use `create(BlameRequestSchema)` to create a new message.
 */
export const BlameRequestSchema: GenMessage<BlameRequest> = /*@__PURE__*/
  messageDesc(file_gd, 21);

/**
 * @generated from message gd.v1.BlameLine
 */
export type BlameLine = Message<"gd.v1.BlameLine"> & {
  /**
   * Changeset that last changed this line.
   *
   * @generated from field: bytes changeset = 1;
   */
  changeset: Uint8Array;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * The line's number (1-based) in that changeset's version of the file.
   *
   * @generated from field: uint32 origin_line = 3;
   */
  originLine: number;

  /**
   * Who wrote it: a key into BlameResponse.authors. Empty when nothing is known beyond the
   * changeset's author, which is not a claim that a person wrote it.
   *
   * @generated from field: string by = 4;
   */
  by: string;
};

/**
 * Describes the message gd.v1.BlameLine.
 * Use `create(BlameLineSchema)` to create a new message.
 */
export const BlameLineSchema: GenMessage<BlameLine> = /*@__PURE__*/
  messageDesc(file_gd, 22);

/**
 * @generated from message gd.v1.LineAuthor
 */
export type LineAuthor = Message<"gd.v1.LineAuthor"> & {
  /**
   * @generated from field: bool agent = 1;
   */
  agent: boolean;

  /**
   * An account (asha, agent/acme-bot), or for git-ai notes the tool (claude_code, cursor) or the
   * person ("Asha Rao <asha@acme.test>").
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string model = 3;
   */
  model: string;

  /**
   * For an agent: the person it worked for, when known.
   *
   * @generated from field: string person = 4;
   */
  person: string;

  /**
   * "grovedock" (recorded by this server) or "git-ai" (from the source repository's notes).
   *
   * @generated from field: string source = 5;
   */
  source: string;
};

/**
 * Describes the message gd.v1.LineAuthor.
 * Use `create(LineAuthorSchema)` to create a new message.
 */
export const LineAuthorSchema: GenMessage<LineAuthor> = /*@__PURE__*/
  messageDesc(file_gd, 23);

/**
 * @generated from message gd.v1.BlameResponse
 */
export type BlameResponse = Message<"gd.v1.BlameResponse"> & {
  /**
   * @generated from field: repeated gd.v1.BlameLine lines = 1;
   */
  lines: BlameLine[];

  /**
   * @generated from field: map<string, gd.v1.LineAuthor> authors = 2;
   */
  authors: { [key: string]: LineAuthor };
};

/**
 * Describes the message gd.v1.BlameResponse.
 * Use `create(BlameResponseSchema)` to create a new message.
 */
export const BlameResponseSchema: GenMessage<BlameResponse> = /*@__PURE__*/
  messageDesc(file_gd, 24);

/**
 * A git-ai authorship note (refs/notes/ai, authorship/3.x) for a change that came from git.
 *
 * @generated from message gd.v1.AttachGitAiNoteRequest
 */
export type AttachGitAiNoteRequest = Message<"gd.v1.AttachGitAiNoteRequest"> & {
  /**
   * @generated from field: bytes changeset = 1;
   */
  changeset: Uint8Array;

  /**
   * @generated from field: string note = 2;
   */
  note: string;
};

/**
 * Describes the message gd.v1.AttachGitAiNoteRequest.
 * Use `create(AttachGitAiNoteRequestSchema)` to create a new message.
 */
export const AttachGitAiNoteRequestSchema: GenMessage<AttachGitAiNoteRequest> = /*@__PURE__*/
  messageDesc(file_gd, 25);

/**
 * @generated from message gd.v1.GitAiNoteResponse
 */
export type GitAiNoteResponse = Message<"gd.v1.GitAiNoteResponse"> & {
  /**
   * @generated from field: string note = 1;
   */
  note: string;
};

/**
 * Describes the message gd.v1.GitAiNoteResponse.
 * Use `create(GitAiNoteResponseSchema)` to create a new message.
 */
export const GitAiNoteResponseSchema: GenMessage<GitAiNoteResponse> = /*@__PURE__*/
  messageDesc(file_gd, 26);

/**
 * @generated from message gd.v1.DiffRequest
 */
export type DiffRequest = Message<"gd.v1.DiffRequest"> & {
  /**
   * @generated from field: string from = 1;
   */
  from: string;

  /**
   * @generated from field: string to = 2;
   */
  to: string;
};

/**
 * Describes the message gd.v1.DiffRequest.
 * Use `create(DiffRequestSchema)` to create a new message.
 */
export const DiffRequestSchema: GenMessage<DiffRequest> = /*@__PURE__*/
  messageDesc(file_gd, 27);

/**
 * @generated from message gd.v1.DiffResponse
 */
export type DiffResponse = Message<"gd.v1.DiffResponse"> & {
  /**
   * @generated from field: repeated gd.v1.FileChange changes = 1;
   */
  changes: FileChange[];
};

/**
 * Describes the message gd.v1.DiffResponse.
 * Use `create(DiffResponseSchema)` to create a new message.
 */
export const DiffResponseSchema: GenMessage<DiffResponse> = /*@__PURE__*/
  messageDesc(file_gd, 28);

/**
 * @generated from message gd.v1.MergeBaseRequest
 */
export type MergeBaseRequest = Message<"gd.v1.MergeBaseRequest"> & {
  /**
   * @generated from field: string a = 1;
   */
  a: string;

  /**
   * @generated from field: string b = 2;
   */
  b: string;
};

/**
 * Describes the message gd.v1.MergeBaseRequest.
 * Use `create(MergeBaseRequestSchema)` to create a new message.
 */
export const MergeBaseRequestSchema: GenMessage<MergeBaseRequest> = /*@__PURE__*/
  messageDesc(file_gd, 29);

/**
 * @generated from message gd.v1.MergeBaseResponse
 */
export type MergeBaseResponse = Message<"gd.v1.MergeBaseResponse"> & {
  /**
   * @generated from field: bool found = 1;
   */
  found: boolean;

  /**
   * @generated from field: bytes id = 2;
   */
  id: Uint8Array;
};

/**
 * Describes the message gd.v1.MergeBaseResponse.
 * Use `create(MergeBaseResponseSchema)` to create a new message.
 */
export const MergeBaseResponseSchema: GenMessage<MergeBaseResponse> = /*@__PURE__*/
  messageDesc(file_gd, 30);

/**
 * @generated from message gd.v1.BrowseRequest
 */
export type BrowseRequest = Message<"gd.v1.BrowseRequest"> & {
  /**
   * @generated from field: string rev = 1;
   */
  rev: string;

  /**
   * @generated from field: string path = 2;
   */
  path: string;
};

/**
 * Describes the message gd.v1.BrowseRequest.
 * Use `create(BrowseRequestSchema)` to create a new message.
 */
export const BrowseRequestSchema: GenMessage<BrowseRequest> = /*@__PURE__*/
  messageDesc(file_gd, 31);

/**
 * @generated from message gd.v1.DirEntry
 */
export type DirEntry = Message<"gd.v1.DirEntry"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int32 mode = 2;
   */
  mode: number;

  /**
   * @generated from field: bytes id = 3;
   */
  id: Uint8Array;
};

/**
 * Describes the message gd.v1.DirEntry.
 * Use `create(DirEntrySchema)` to create a new message.
 */
export const DirEntrySchema: GenMessage<DirEntry> = /*@__PURE__*/
  messageDesc(file_gd, 32);

/**
 * @generated from message gd.v1.ListDirResponse
 */
export type ListDirResponse = Message<"gd.v1.ListDirResponse"> & {
  /**
   * @generated from field: repeated gd.v1.DirEntry entries = 1;
   */
  entries: DirEntry[];
};

/**
 * Describes the message gd.v1.ListDirResponse.
 * Use `create(ListDirResponseSchema)` to create a new message.
 */
export const ListDirResponseSchema: GenMessage<ListDirResponse> = /*@__PURE__*/
  messageDesc(file_gd, 33);

/**
 * @generated from message gd.v1.ReadFileResponse
 */
export type ReadFileResponse = Message<"gd.v1.ReadFileResponse"> & {
  /**
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;

  /**
   * @generated from field: int32 mode = 2;
   */
  mode: number;

  /**
   * @generated from field: bytes id = 3;
   */
  id: Uint8Array;
};

/**
 * Describes the message gd.v1.ReadFileResponse.
 * Use `create(ReadFileResponseSchema)` to create a new message.
 */
export const ReadFileResponseSchema: GenMessage<ReadFileResponse> = /*@__PURE__*/
  messageDesc(file_gd, 34);

/**
 * @generated from message gd.v1.FindRequest
 */
export type FindRequest = Message<"gd.v1.FindRequest"> & {
  /**
   * @generated from field: string rev = 1;
   */
  rev: string;

  /**
   * Case-sensitive substring matched against full repo paths.
   *
   * @generated from field: string pattern = 2;
   */
  pattern: string;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message gd.v1.FindRequest.
 * Use `create(FindRequestSchema)` to create a new message.
 */
export const FindRequestSchema: GenMessage<FindRequest> = /*@__PURE__*/
  messageDesc(file_gd, 35);

/**
 * @generated from message gd.v1.FindResponse
 */
export type FindResponse = Message<"gd.v1.FindResponse"> & {
  /**
   * @generated from field: repeated string paths = 1;
   */
  paths: string[];

  /**
   * @generated from field: bool truncated = 2;
   */
  truncated: boolean;
};

/**
 * Describes the message gd.v1.FindResponse.
 * Use `create(FindResponseSchema)` to create a new message.
 */
export const FindResponseSchema: GenMessage<FindResponse> = /*@__PURE__*/
  messageDesc(file_gd, 36);

/**
 * @generated from message gd.v1.CheckoutRequest
 */
export type CheckoutRequest = Message<"gd.v1.CheckoutRequest"> & {
  /**
   * @generated from field: string rev = 1;
   */
  rev: string;

  /**
   * Paths (files or directories) to materialise; empty = everything readable.
   *
   * @generated from field: repeated string paths = 2;
   */
  paths: string[];
};

/**
 * Describes the message gd.v1.CheckoutRequest.
 * Use `create(CheckoutRequestSchema)` to create a new message.
 */
export const CheckoutRequestSchema: GenMessage<CheckoutRequest> = /*@__PURE__*/
  messageDesc(file_gd, 37);

/**
 * Files are streamed in pieces of at most 4 MiB; every piece names its file, and the
 * last piece of a file has `last` set. Clients verify each file's content against `id`.
 *
 * @generated from message gd.v1.CheckoutPiece
 */
export type CheckoutPiece = Message<"gd.v1.CheckoutPiece"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: int32 mode = 2;
   */
  mode: number;

  /**
   * @generated from field: bytes id = 3;
   */
  id: Uint8Array;

  /**
   * @generated from field: bytes data = 4;
   */
  data: Uint8Array;

  /**
   * @generated from field: bool last = 5;
   */
  last: boolean;
};

/**
 * Describes the message gd.v1.CheckoutPiece.
 * Use `create(CheckoutPieceSchema)` to create a new message.
 */
export const CheckoutPieceSchema: GenMessage<CheckoutPiece> = /*@__PURE__*/
  messageDesc(file_gd, 38);

/**
 * API-first file access: CI and tools read source without any checkout.
 * Code search over a branch: text (every term, 3 characters or more, case-insensitive) and
 * symbol definitions. Servers index a branch the first time it's searched and keep the index
 * up to date as it moves; results only include files the caller may read.
 *
 * @generated from message gd.v1.SearchCodeRequest
 */
export type SearchCodeRequest = Message<"gd.v1.SearchCodeRequest"> & {
  /**
   * Words or "quoted phrases", all of which a file must contain, plus `path:dir/` and
   * `-path:dir/` to narrow by path and `lang:rs` by language.
   *
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * The branch; empty: main.
   *
   * @generated from field: string ref = 2;
   */
  ref: string;

  /**
   * Files per page (default 20, at most 100).
   *
   * @generated from field: uint32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string page_token = 4;
   */
  pageToken: string;
};

/**
 * Describes the message gd.v1.SearchCodeRequest.
 * Use `create(SearchCodeRequestSchema)` to create a new message.
 */
export const SearchCodeRequestSchema: GenMessage<SearchCodeRequest> = /*@__PURE__*/
  messageDesc(file_gd, 39);

/**
 * @generated from message gd.v1.CodeLine
 */
export type CodeLine = Message<"gd.v1.CodeLine"> & {
  /**
   * @generated from field: uint32 line = 1;
   */
  line: number;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * Where the terms are in `text`: start, end pairs in characters.
   *
   * @generated from field: repeated uint32 ranges = 3;
   */
  ranges: number[];
};

/**
 * Describes the message gd.v1.CodeLine.
 * Use `create(CodeLineSchema)` to create a new message.
 */
export const CodeLineSchema: GenMessage<CodeLine> = /*@__PURE__*/
  messageDesc(file_gd, 40);

/**
 * @generated from message gd.v1.CodeHit
 */
export type CodeHit = Message<"gd.v1.CodeHit"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: repeated gd.v1.CodeLine lines = 2;
   */
  lines: CodeLine[];

  /**
   * Matching lines not shown.
   *
   * @generated from field: uint32 more = 3;
   */
  more: number;
};

/**
 * Describes the message gd.v1.CodeHit.
 * Use `create(CodeHitSchema)` to create a new message.
 */
export const CodeHitSchema: GenMessage<CodeHit> = /*@__PURE__*/
  messageDesc(file_gd, 41);

/**
 * @generated from message gd.v1.SearchCodeResponse
 */
export type SearchCodeResponse = Message<"gd.v1.SearchCodeResponse"> & {
  /**
   * @generated from field: repeated gd.v1.CodeHit hits = 1;
   */
  hits: CodeHit[];

  /**
   * Files that match, up to 5,000.
   *
   * @generated from field: uint32 files = 2;
   */
  files: number;

  /**
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken: string;

  /**
   * The changeset the index is at, and whether the branch has moved past it (the index is
   * catching up).
   *
   * @generated from field: bytes indexed_at = 4;
   */
  indexedAt: Uint8Array;

  /**
   * @generated from field: bool catching_up = 5;
   */
  catchingUp: boolean;
};

/**
 * Describes the message gd.v1.SearchCodeResponse.
 * Use `create(SearchCodeResponseSchema)` to create a new message.
 */
export const SearchCodeResponseSchema: GenMessage<SearchCodeResponse> = /*@__PURE__*/
  messageDesc(file_gd, 42);

/**
 * @generated from message gd.v1.FindSymbolRequest
 */
export type FindSymbolRequest = Message<"gd.v1.FindSymbolRequest"> & {
  /**
   * The name, or its start.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string ref = 2;
   */
  ref: string;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message gd.v1.FindSymbolRequest.
 * Use `create(FindSymbolRequestSchema)` to create a new message.
 */
export const FindSymbolRequestSchema: GenMessage<FindSymbolRequest> = /*@__PURE__*/
  messageDesc(file_gd, 43);

/**
 * @generated from message gd.v1.SymbolHit
 */
export type SymbolHit = Message<"gd.v1.SymbolHit"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * fn, struct, class, interface, type, def, …
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * @generated from field: uint32 line = 4;
   */
  line: number;

  /**
   * The line that defines it.
   *
   * @generated from field: string text = 5;
   */
  text: string;
};

/**
 * Describes the message gd.v1.SymbolHit.
 * Use `create(SymbolHitSchema)` to create a new message.
 */
export const SymbolHitSchema: GenMessage<SymbolHit> = /*@__PURE__*/
  messageDesc(file_gd, 44);

/**
 * @generated from message gd.v1.FindSymbolResponse
 */
export type FindSymbolResponse = Message<"gd.v1.FindSymbolResponse"> & {
  /**
   * @generated from field: repeated gd.v1.SymbolHit symbols = 1;
   */
  symbols: SymbolHit[];

  /**
   * @generated from field: bytes indexed_at = 2;
   */
  indexedAt: Uint8Array;

  /**
   * @generated from field: bool catching_up = 3;
   */
  catchingUp: boolean;
};

/**
 * Describes the message gd.v1.FindSymbolResponse.
 * Use `create(FindSymbolResponseSchema)` to create a new message.
 */
export const FindSymbolResponseSchema: GenMessage<FindSymbolResponse> = /*@__PURE__*/
  messageDesc(file_gd, 45);

/**
 * @generated from message gd.v1.WhoAmIResponse
 */
export type WhoAmIResponse = Message<"gd.v1.WhoAmIResponse"> & {
  /**
   * @generated from field: string principal = 1;
   */
  principal: string;

  /**
   * @generated from field: bool full_read = 2;
   */
  fullRead: boolean;

  /**
   * @generated from field: repeated string read_prefixes = 3;
   */
  readPrefixes: string[];
};

/**
 * Describes the message gd.v1.WhoAmIResponse.
 * Use `create(WhoAmIResponseSchema)` to create a new message.
 */
export const WhoAmIResponseSchema: GenMessage<WhoAmIResponse> = /*@__PURE__*/
  messageDesc(file_gd, 46);

/**
 * Exclusive locks on files that cannot be merged (art, models, video, binaries). A lock
 * does not block reads; landing a change to a path someone else has locked is refused.
 *
 * @generated from message gd.v1.LockRequest
 */
export type LockRequest = Message<"gd.v1.LockRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;
};

/**
 * Describes the message gd.v1.LockRequest.
 * Use `create(LockRequestSchema)` to create a new message.
 */
export const LockRequestSchema: GenMessage<LockRequest> = /*@__PURE__*/
  messageDesc(file_gd, 47);

/**
 * @generated from message gd.v1.UnlockRequest
 */
export type UnlockRequest = Message<"gd.v1.UnlockRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * Release another person's lock (needs write access to the path).
   *
   * @generated from field: bool force = 2;
   */
  force: boolean;
};

/**
 * Describes the message gd.v1.UnlockRequest.
 * Use `create(UnlockRequestSchema)` to create a new message.
 */
export const UnlockRequestSchema: GenMessage<UnlockRequest> = /*@__PURE__*/
  messageDesc(file_gd, 48);

/**
 * @generated from message gd.v1.ListLocksRequest
 */
export type ListLocksRequest = Message<"gd.v1.ListLocksRequest"> & {
  /**
   * @generated from field: string prefix = 1;
   */
  prefix: string;
};

/**
 * Describes the message gd.v1.ListLocksRequest.
 * Use `create(ListLocksRequestSchema)` to create a new message.
 */
export const ListLocksRequestSchema: GenMessage<ListLocksRequest> = /*@__PURE__*/
  messageDesc(file_gd, 49);

/**
 * @generated from message gd.v1.LockInfo
 */
export type LockInfo = Message<"gd.v1.LockInfo"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: string owner = 2;
   */
  owner: string;

  /**
   * @generated from field: int64 locked_at_ms = 3;
   */
  lockedAtMs: bigint;
};

/**
 * Describes the message gd.v1.LockInfo.
 * Use `create(LockInfoSchema)` to create a new message.
 */
export const LockInfoSchema: GenMessage<LockInfo> = /*@__PURE__*/
  messageDesc(file_gd, 50);

/**
 * @generated from message gd.v1.LockList
 */
export type LockList = Message<"gd.v1.LockList"> & {
  /**
   * @generated from field: repeated gd.v1.LockInfo locks = 1;
   */
  locks: LockInfo[];
};

/**
 * Describes the message gd.v1.LockList.
 * Use `create(LockListSchema)` to create a new message.
 */
export const LockListSchema: GenMessage<LockList> = /*@__PURE__*/
  messageDesc(file_gd, 51);

/**
 * Tier-agnostic object service. Served identically by server, cache and daemon.
 *
 * @generated from service gd.v1.Objects
 */
export const Objects: GenService<{
  /**
   * @generated from rpc gd.v1.Objects.Get
   */
  get: {
    methodKind: "server_streaming";
    input: typeof IdListSchema;
    output: typeof ObjectPayloadSchema;
  },
  /**
   * @generated from rpc gd.v1.Objects.Put
   */
  put: {
    methodKind: "client_streaming";
    input: typeof ObjectPayloadSchema;
    output: typeof PutObjectsResponseSchema;
  },
  /**
   * Returns the subset of ids the tier cannot serve.
   *
   * @generated from rpc gd.v1.Objects.Missing
   */
  missing: {
    methodKind: "unary";
    input: typeof IdListSchema;
    output: typeof IdListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 0);

/**
 * @generated from service gd.v1.Changesets
 */
export const Changesets: GenService<{
  /**
   * @generated from rpc gd.v1.Changesets.Create
   */
  create: {
    methodKind: "unary";
    input: typeof CreateChangesetRequestSchema;
    output: typeof ChangesetInfoSchema;
  },
  /**
   * Creates changes in the order sent and answers each with its id, so a client sends a whole
   * history without waiting a round trip per change (imports, git pushes). Parents may refer to
   * changes made earlier on the stream. At most 10,000 changes per call.
   *
   * @generated from rpc gd.v1.Changesets.CreateMany
   */
  createMany: {
    methodKind: "bidi_streaming";
    input: typeof CreateChangesetRequestSchema;
    output: typeof CreatedChangesetSchema;
  },
  /**
   * @generated from rpc gd.v1.Changesets.Get
   */
  get: {
    methodKind: "unary";
    input: typeof ResolveRequestSchema;
    output: typeof ChangesetInfoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 1);

/**
 * Refs name changesets: branches, and tags under `tags/` (`tags/v1.2.0`). A tag is made once
 * (CompareAndSwap from nothing) and never moves: swapping an existing tag fails, and nothing
 * lands on one. Git sees them as refs/tags/*.
 *
 * @generated from service gd.v1.Refs
 */
export const Refs: GenService<{
  /**
   * @generated from rpc gd.v1.Refs.Get
   */
  get: {
    methodKind: "unary";
    input: typeof RefNameSchema;
    output: typeof RefValueSchema;
  },
  /**
   * @generated from rpc gd.v1.Refs.CompareAndSwap
   */
  compareAndSwap: {
    methodKind: "unary";
    input: typeof CasRequestSchema;
    output: typeof CasResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Refs.List
   */
  list: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof RefListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 2);

/**
 * Server-side rebase + lock-free compare-and-swap of a ref.
 *
 * @generated from service gd.v1.Land
 */
export const Land: GenService<{
  /**
   * @generated from rpc gd.v1.Land.Land
   */
  land: {
    methodKind: "unary";
    input: typeof LandRequestSchema;
    output: typeof LandResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 3);

/**
 * @generated from service gd.v1.History
 */
export const History: GenService<{
  /**
   * @generated from rpc gd.v1.History.Log
   */
  log: {
    methodKind: "server_streaming";
    input: typeof LogRequestSchema;
    output: typeof ChangesetInfoSchema;
  },
  /**
   * @generated from rpc gd.v1.History.Blame
   */
  blame: {
    methodKind: "unary";
    input: typeof BlameRequestSchema;
    output: typeof BlameResponseSchema;
  },
  /**
   * Keeps which lines of an imported change an agent wrote. Only for changes that came from
   * git (their notes are the source repository's claim); needs write access.
   *
   * @generated from rpc gd.v1.History.AttachGitAiNote
   */
  attachGitAiNote: {
    methodKind: "unary";
    input: typeof AttachGitAiNoteRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * The git-ai note kept with a change that came from git; empty when there is none.
   *
   * @generated from rpc gd.v1.History.GitAiNote
   */
  gitAiNote: {
    methodKind: "unary";
    input: typeof IdMsgSchema;
    output: typeof GitAiNoteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 4);

/**
 * @generated from service gd.v1.Diff
 */
export const Diff: GenService<{
  /**
   * @generated from rpc gd.v1.Diff.Diff
   */
  diff: {
    methodKind: "unary";
    input: typeof DiffRequestSchema;
    output: typeof DiffResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 5);

/**
 * @generated from service gd.v1.MergeBase
 */
export const MergeBase: GenService<{
  /**
   * @generated from rpc gd.v1.MergeBase.MergeBase
   */
  mergeBase: {
    methodKind: "unary";
    input: typeof MergeBaseRequestSchema;
    output: typeof MergeBaseResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 6);

/**
 * @generated from service gd.v1.CodeSearch
 */
export const CodeSearch: GenService<{
  /**
   * @generated from rpc gd.v1.CodeSearch.SearchCode
   */
  searchCode: {
    methodKind: "unary";
    input: typeof SearchCodeRequestSchema;
    output: typeof SearchCodeResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.CodeSearch.FindSymbol
   */
  findSymbol: {
    methodKind: "unary";
    input: typeof FindSymbolRequestSchema;
    output: typeof FindSymbolResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 7);

/**
 * @generated from service gd.v1.Browse
 */
export const Browse: GenService<{
  /**
   * @generated from rpc gd.v1.Browse.ListDir
   */
  listDir: {
    methodKind: "unary";
    input: typeof BrowseRequestSchema;
    output: typeof ListDirResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Browse.ReadFile
   */
  readFile: {
    methodKind: "unary";
    input: typeof BrowseRequestSchema;
    output: typeof ReadFileResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Browse.Find
   */
  find: {
    methodKind: "unary";
    input: typeof FindRequestSchema;
    output: typeof FindResponseSchema;
  },
  /**
   * Path-scoped checkout: only files the caller may read. Used by principals with
   * restricted read access, who may not read objects by id.
   *
   * @generated from rpc gd.v1.Browse.Checkout
   */
  checkout: {
    methodKind: "server_streaming";
    input: typeof CheckoutRequestSchema;
    output: typeof CheckoutPieceSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 8);

/**
 * @generated from service gd.v1.Access
 */
export const Access: GenService<{
  /**
   * @generated from rpc gd.v1.Access.WhoAmI
   */
  whoAmI: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof WhoAmIResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 9);

/**
 * @generated from service gd.v1.Locks
 */
export const Locks: GenService<{
  /**
   * @generated from rpc gd.v1.Locks.Lock
   */
  lock: {
    methodKind: "unary";
    input: typeof LockRequestSchema;
    output: typeof LockInfoSchema;
  },
  /**
   * @generated from rpc gd.v1.Locks.Unlock
   */
  unlock: {
    methodKind: "unary";
    input: typeof UnlockRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc gd.v1.Locks.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListLocksRequestSchema;
    output: typeof LockListSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd, 10);

